export default __webpack_public_path__ + "static/media/docdoor.15004553.png";